import React, { useState } from "react";
import { Label } from "@progress/kendo-react-labels";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { Field } from "@progress/kendo-react-form";

export default function Nominals({
  label,
  disabled = false,
  nominalList,
  width = "255px",
  controlled = false,
  name,
  className,
  onChange,
  value,
  style,
}) {
  const [filter, setFilter] = useState("");

  const filteredData = filter
    ? (nominalList ?? []).filter((item) => {
      const search = filter.toLowerCase();
      return (
        item.nominalRef?.toLowerCase().includes(search) ||
        item.nominalName?.toLowerCase().includes(search) ||
        item.display?.toLowerCase().includes(search)
      );
    })
    : nominalList;

  return (
    <div className={`${className} d-flex flex-column`} style={style}>
      <Label className="label mb-2">{label}</Label>
      {controlled ? (
        <ComboBox
          style={{ width: width, height: "44px" }}
          data={filteredData}
          textField="display"
          placeholder="Select Nominal"
          dataItemKey="nominalRef"
          iconClassName="wa"
          className="ps-2"
          value={value}
          onChange={(e) => {
            setFilter("");
            onChange(e.value);
          }}
          filterable={true}
          onFilterChange={(e) => setFilter(e.filter.value)}
        />
      ) : (
        <Field
          disabled={disabled}
          style={{ width: width, height: "44px" }}
          data={nominalList}
          name={name}
          textField="display"
          placeholder="Select Nominal"
          className="ps-2"
          dataItemKey="nominalRef"
          iconClassName="wa"
          component={ComboBox}
        />
      )}
    </div>
  );
}
